var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"title":_vm.t('Cells')}}),_c('div',{staticClass:"ma-3"},[_c('h3',{staticClass:"accent--text"},[_vm._v(" "+_vm._s(_vm.t('Welcome'))+" ")]),_c('div',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.t('Intro'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }